module.exports = __webpack_public_path__ + "img/26_184.404ac77b.png";